import { render } from "./CardAdd.vue?vue&type=template&id=fa0c8568"
import script from "./CardAdd.vue?vue&type=script&lang=js"
export * from "./CardAdd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__